import * as React from 'react';
import { useLazyQuery as useLazyQuery$2 } from '@apollo/client';
import { handleError } from './helpers.js';

const useLazyQuery = (query, options)=>{
    const [executable, result] = useLazyQuery$2(query, options);
    const { error  } = result;
    React.useEffect(()=>{
        if (error) {
            handleError(query, error);
        }
    }, [
        error,
        query
    ]);
    return [
        executable,
        result
    ];
};
var useLazyQuery$1 = useLazyQuery;

export { useLazyQuery$1 as default };
//# sourceMappingURL=use-lazy-query.js.map
